import Nav from "../Nav";
import Carousel from "../Carousel";
import Head from "../Head";

export const LaboratorioAmbulante = () => {
  var settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 3000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
        },
      },
    ],
  };

  return (
    <>
      <Head title="Muestras -  Algae" />
      <Nav titulo="Algae" link="/muestras" />
     
      <section
        id="about_me"
        className="mb-5  animate__fadeInDown wow animate__animated animate__delay-0s animate__slower"
      >
         <Carousel settings={settings}>
      <img
            src="../img/algas_y_mar/algas_y_mar (14).jpg"
            className="img-fluid"
            alt="Algas y mar"
          />
           <img
            src="../img/algas_y_mar/algas_y_mar (8).jpg"
            className="img-fluid"
            alt="Algas y mar"
          /> <img
          src="../img/algas_y_mar/algas_y_mar (15).jpg"
          className="img-fluid"
          alt="Algas y mar"
        />
         <img
            src="../img/algas_y_mar/algas_y_mar (10).jpg"
            className="img-fluid"
            alt="Algas y mar"
          />
           <img
            src="../img/algas_y_mar/algas_y_mar (6).jpg"
            className="img-fluid"
            alt="Algas y mar"
          />
           <img
            src="../img/algas_y_mar/algas_y_mar (5).jpg"
            className="img-fluid"
            alt="Algas y mar"
          />
           <img
            src="../img/algas_y_mar/algas_y_mar (2).jpg"
            className="img-fluid"
            alt="Algas y mar"
          />
           <img
            src="../img/algas_y_mar/algas_y_mar (3).jpg"
            className="img-fluid"
            alt="Algas y mar"
          />
           <img
            src="../img/algas_y_mar/algas_y_mar (1).jpg"
            className="img-fluid"
            alt="Algas y mar"
          />
           <img
            src="../img/algas_y_mar/algas_y_mar (13).jpg"
            className="img-fluid"
            alt="Algas y mar"
          />
           <img
            src="../img/algas_y_mar/algas_y_mar (11).jpg"
            className="img-fluid"
            alt="Algas y mar"
          />
           <img
            src="../img/algas_y_mar/algas_y_mar (7).jpg"
            className="img-fluid"
            alt="Algas y mar"
          />
           <img
            src="../img/algas_y_mar/algas_y_mar (4).jpg"
            className="img-fluid"
            alt="Algas y mar"
          />
           <img
            src="../img/algas_y_mar/algas_y_mar (12).jpg"
            className="img-fluid"
            alt="Algas y mar"
          />
           <img
            src="../img/algas_y_mar/algas_y_mar (9).jpg"
            className="img-fluid"
            alt="Algas y mar"
          />
      </Carousel>
        <div className="row marMob ">
          <div className="col-12 mt-5 col-lg-7 text-md-start col-xl-9">
            <hr />
            <h3 className="text-center fs-6">Laboratorio ambulante: revelados con algas </h3>
            <p className="text-center">En el marco de la residencia Mudar 2022, Cabo Polonio, Uruguay.</p>
            <hr />
          </div>
        </div>
      </section>
    </>
  );
};
